import React, { useContext } from 'react';
import propTypes from 'prop-types';
import { QuantitySelector } from '../QuantitySelector';
import { QuantityContext } from '../QuantitySelector/QuantityProvider';
import { formatCurrency } from '../../utilities/financing';
import { productPropTypes } from './productPropTypes';

const TireCard = ({
  product,
  isSplitFitment,
  frontTire,
  pricing,
}) => {
  const {
    modelName,
    sku,
    brand,
    productDetails,
  } = product;
  const { size } = productDetails;
  const { quantities } = useContext(QuantityContext);

  const getUnitPrice = (p) => (
    formatCurrency(pricing[p.sku])
  );

  const getTotalPrice = (p) => {
    const quantity = frontTire ? quantities.qtyFront : quantities.qtyRear;

    return (pricing[p.sku] * quantity).toFixed(2);
  };

  const getSplitFitmentText = () => (
    frontTire
      ? 'Front Tire(s):'
      : 'Rear Tire(s):'
  );

  const getSizeText = () => (
    isSplitFitment
      ? getSplitFitmentText()
      : 'Size:'
  );

  return (
    <div className="cmp-tire-card">
      <div className="cmp-tire-card__image">
        <img src={`${product.images?.[0]?.url ?? '/themes/custom/tire_discounters/public/images/no-image-available.png'}?width=224&height=240`} alt="" width="224" height="240" loading="lazy" />
      </div>
      <div className="cmp-tire-card__overview">
        <p className="cmp-tire-card__manufacturer">{brand.name}</p>
        <p className="cmp-tire-card__model">{modelName}</p>
        <div className="cmp-tire-card__specs">
          <ul>
            <li>
              {getSizeText()}
              {' '}
              <span>
                {size}
              </span>
            </li>
            <li>
              Part
              {' '}
              #
              {product.primaryManufacturer.sku}
            </li>
          </ul>
        </div>
      </div>
      <div className="cmp-tire-card__pricing">
        <div>
          <QuantitySelector
            sku={sku}
            isSplitFitment={isSplitFitment}
            isFrontTire={frontTire}
          />
        </div>
        <div className="util-weight-bold">
          <div className="cmp-tire-card__price-total">
            <span className="cmp-tire-card__dollar-sign">$</span>
            {getTotalPrice(product)}
          </div>
          <div className="cmp-tire-card__price-unit">
            {getUnitPrice(product)}
            {' '}
            per tire
          </div>
        </div>
      </div>
    </div>
  );
};

TireCard.propTypes = {
  isSplitFitment: propTypes.bool,
  frontTire: propTypes.bool,
  product: productPropTypes,
  pricing: propTypes.shape({
    isValidPrice: propTypes.bool,
    pricingGroup: propTypes.string,
  }),
};

export { TireCard };
